import { useGateValue } from '@rover/rsdk/src/modules/Statsig';

export const useShouldShowNewManagementHub = (): boolean =>
  useGateValue('rollout_management_hub_migration');
